var map = {
	"./arrow-fill.svg": 401,
	"./back-arrow.svg": 402,
	"./bell.svg": 403,
	"./caret-down.svg": 404,
	"./caret-left.svg": 405,
	"./caret-right.svg": 406,
	"./check.svg": 407,
	"./checkbox--off.svg": 408,
	"./checkbox--on.svg": 409,
	"./close.svg": 410,
	"./controls.svg": 411,
	"./delete.svg": 412,
	"./error.svg": 413,
	"./flag-off.svg": 414,
	"./flag-on.svg": 415,
	"./heart.svg": 416,
	"./helpful-off.svg": 417,
	"./helpful-on.svg": 418,
	"./info.svg": 419,
	"./logout.svg": 420,
	"./moderate.svg": 421,
	"./more-H.svg": 422,
	"./next-arrow.svg": 423,
	"./options-collapse.svg": 424,
	"./options-expand.svg": 425,
	"./photo.svg": 426,
	"./posts.svg": 427,
	"./profile.svg": 428,
	"./question.svg": 429,
	"./quote.svg": 430,
	"./reply.svg": 431,
	"./search.svg": 432,
	"./settings.svg": 433,
	"./social-facebook.svg": 434,
	"./social-google.svg": 435,
	"./social-pinterest.svg": 436,
	"./social-twitter.svg": 437,
	"./sort.svg": 438,
	"./star--empty.svg": 439,
	"./star--full.svg": 440,
	"./star--half.svg": 441,
	"./unhelpful-off.svg": 442,
	"./unhelpful-on.svg": 443,
	"./video.svg": 444,
	"./vote-off.svg": 445,
	"./vote-on.svg": 446,
	"./write.svg": 447
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 400;


//////////////////
// WEBPACK FOOTER
// ./src/build/VuTUYdwvqIExdDFsite/assets/svg/search-page .svg$
// module id = 400
// module chunks = 11